import httpService from '@Utils/httpService';

const baseUrl = 'api/Management/Releases/Jira';

export default {
  getProjects() {
    return httpService.get({
      url: `${baseUrl}/projects`,
    });
  },
  // params: { projectKey, status, search, page, itemsPerPage }
  getVersions(params) {
    return httpService.get({
      url: `${baseUrl}/versions`,
      params,
    });
  },
  getVersionIssues(versionId) {
    return httpService.get({
      url: `${baseUrl}/versions/${versionId}/issues`,
    });
  },
  getHealth() {
    return httpService.get({
      url: `${baseUrl}/health`,
    });
  },
};
